import { useEffect, useState } from "react";
import LoansSkeleton from "../navigationButtonComponents/loansTab/Loans/loansSkeleton";
import { useDispatch } from "react-redux";
import { setHeaderTitle } from "../../redux/headerTitle/headerTitleSlice";
import { changeRouteType, getpervInnerState } from "../../redux/handleBackBtn/handleBackBtnSlice";
import FourPartsCard from "../../components/card/fourPartsCard/fourPartsCard";
import EmptyStyle from "../../components/emptyStyles/emptyStyle";
import { IGetWaitForCustomerApproveSalesResponse } from "../../models/sale.model";
import { IInnerStateHomeMenu } from "../navigationButtonComponents/homeTab/IHomeMenu";
import { SALE_ID } from "../../config/cacheKey";
import { useQueryClient } from "react-query";


export default function OngoingPurchases({ setState, setTabChild, waitingPurchases }: IInnerStateHomeMenu) {

    const queryClient = useQueryClient();
    const randomKeyForDispatch = Math.random();
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(setHeaderTitle({ color: 'var(--header-color)', header: 'خریدهای در جریان', parentRoute: 'home' }));
        dispatch(changeRouteType({ routeType: 'child' }));
        dispatch(getpervInnerState({ prevInnerState: `home ${randomKeyForDispatch}` }));
    }, []);



    const handleDetail = (saleKey: string) => {
        setState!('ongoingDetailPurchase');
        queryClient.setQueryData(SALE_ID, saleKey);
    }
    return (
        <>
            <div className='p-5' style={{ height: 'calc(100svh - 60px)', overflowY: 'scroll' }}>
                {waitingPurchases && waitingPurchases.length > 0 ? <>{waitingPurchases?.map((item, index) =>
                (<FourPartsCard amount={item.totalAmount} date={item.requestDatePersian} logo={item.storeLogoBase64} companyName={item.storeTitle}
                    onClick={() => handleDetail(item.saleKey)}
                    key={index} />))}
                </> : <></>
                }
            </div>
        </>
    )
}